import { NumberInput } from '@framework/form/inputs/NumberInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { RowElement } from '@framework/ui/components/row/RowElement.tsx';
import { $SpaceCompact } from '../../../../ui/form/SpaceCompact.ts';
import { RuleType } from '../../IRule.ts';
import { CustomValidationRuleMessage } from '../custom/CustomValidationRuleMessage.tsx';

const fieldName = `rules.${RuleType.ItemRange}`;

export interface IItemRangeRuleComponentProps {}

export function ItemRangeRuleComponent(props: IItemRangeRuleComponentProps) {
  return (
    <RowElement>
      <FormItem
        name={`${fieldName}.min`}
        label="Minimo spunte"
        help="Numero minimo di voci spuntate."
      >
        <$SpaceCompact block size="large">
          <NumberInput name={`${fieldName}.min`} />
          <CustomValidationRuleMessage name={`${fieldName}.minCustomMessage`} />
        </$SpaceCompact>
      </FormItem>

      <FormItem
        name={`${fieldName}.max`}
        label="Massimo spunte"
        help="Numero massimo di voci spuntate."
      >
        <$SpaceCompact block size="large">
          <NumberInput name={`${fieldName}.max`} />
          <CustomValidationRuleMessage name={`${fieldName}.maxCustomMessage`} />
        </$SpaceCompact>
      </FormItem>
    </RowElement>
  );
}
